import React from 'react';
import { termsHtml } from '../static/terms';

const Terms = () => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }} dangerouslySetInnerHTML={{ __html: termsHtml(`${process.env.PUBLIC_URL}/images/mini-logo.png`) }}></div>
  )
}

export default Terms;